
const config = { attributes: true, childList: true, subtree: true };
let targetNode;

var timeinterval = setInterval(()=>{
  targetNode = document.body;
  if (targetNode && targetNode.querySelector('.burger')) {
    byo_menu_responsive();
    clearInterval(timeinterval);
  }
},300);


var addToCartTimeinterval = setInterval(()=>{
  let count = 0;
  if ((document.body && document.body.querySelectorAll('button').length > 0) || count>5000) {
    count++;


    // logic to hide or display cart when an item has bee added via ajax
    function checkCartNotEmpty(){
      var checkCartNotEmptyTimeinterval = setInterval(()=>{
        const cart = document.querySelector('.cart-empty');
        let count = 0;
        if (cart?.textContent.indexOf('(0)') == -1) {
          document.body.classList.remove('body-cart-empty');
          clearInterval(checkCartNotEmptyTimeinterval);
        }

        if (count > 2000) {
          count++;
          clearInterval(checkCartNotEmptyTimeinterval);
        }
      }, 300)
    }

      document.body.querySelectorAll('button').forEach((button, i) => {
        button.addEventListener('click', checkCartNotEmpty)
      });

    // console.log(jQuery._data( jQuery(document.body)[0], "events" ));

    clearInterval(addToCartTimeinterval);
  }
}, 300)


function byo_menu_responsive() {
    function displayMobileMenu(nav1, nav2){

      if (nav2.length > 1) {
        const tophatContainerWidth = nav1.querySelector('.tophat-row-left')?.offsetWidth +
                                     nav1.querySelector('.tophat-row-right')?.offsetWidth;
        const bottomContainerWidth = nav2[1].querySelector('.nav-links-wrapper')?.offsetWidth;

        const collapseWrappers = document.querySelectorAll('.collapse-wrapper');

        if ((window.innerWidth - bottomContainerWidth < 50) || (window.innerWidth - tophatContainerWidth < 50)){
          // nav1.closest('.tophat').style.transform = 'translateY(-112px)';
          nav1.closest('.tophat').style.marginTop = '-27px';
          nav2[0].style.marginTop = '-23px';
          nav2[0].classList.add('byo-responsive-nav_mobile');
          nav2[0].querySelector('.nav-links-wrapper')?.classList.remove('hidden-nav');

          collapseWrappers.forEach((item, i) => {
            item.style.display = 'block';
          });

          document.querySelector('.search-mobile').style.display = 'block';

          // if ( document.querySelector('.burger').classList.contains('toggle') ) {
          //   document.querySelector('.site-header').classList.add('cover-all');
          //   document.querySelector('.site-header').parentElement.style.marginBottom = '149px';
          // }

          const showItems = document.querySelector('.show-items');

          showItems.classList.remove('remove-background');

        }else {
          // nav1.closest('.tophat').style.transform = 'translateY(0px)';
          nav1.closest('.tophat').style.marginTop = '0px';
          nav2[0].style.marginTop = '0px';
          nav2[0].classList.remove('byo-responsive-nav_mobile');
          nav2[0].querySelector('.nav-links-wrapper')?.classList.add('hidden-nav');

          document.querySelector('.search-mobile').style.display = 'none';
          // document.querySelector('.site-header').classList.remove('cover-all');
          // document.querySelector('.site-header').parentElement.style.marginBottom = '0px';

          const navActive = document.querySelector('.nav-active');
          const showItems = document.querySelector('.show-items');
          const burger = document.querySelector('.burger');

          burger.classList.remove('toggle');

          showItems.classList.add('remove-background');

          if (navActive) {
            navActive.classList.remove('nav-active');
          }


          collapseWrappers.forEach((item, i) => {
            item.style.display = 'none';
          });

          // nav1.closest('.tophat')?.style.position = 'relative';
          // nav1.closest('.tophat')?.style.marginTop = '0px';

          const navCollapses = document.querySelectorAll('.nav-collapse');
          navCollapses.forEach((navCollapse, i) => {
            const navLinksUl = navCollapse.parentElement.nextElementSibling.querySelectorAll('ul');

            navLinksUl.forEach((navLinkUl, i) => {
              navLinkUl.style.height = 'auto';
              if (navLinkUl.getAttribute('id') == 'tophat-right' || navLinkUl.classList.contains('primary-right-ul')) {
                navLinkUl.style.marginTop = '0px';
              }
            });
          });
        }
        nav1.closest('.tophat').style.opacity = '1';
        document.querySelector('.display-after-width-check')?.classList.remove('display-after-width-check');
      }


    }

    let eventListenerAdded = false;

    var menuStateTimeinterval = setInterval(()=>{
      let topMenuNav = document.querySelector('.tophat-row');
      let bottomMenuNav = document.querySelectorAll('.byo-responsive-nav');
      if (bottomMenuNav && topMenuNav) {
        displayMobileMenu(topMenuNav, bottomMenuNav);
        if (!eventListenerAdded) {
          window.addEventListener('resize', displayMobileMenu.bind(this, topMenuNav, bottomMenuNav));
          eventListenerAdded = true;
        }

        const navSlide = () => {
        const burger = document.querySelector('.burger');
        const nav = document.querySelector('.nav-links-wrapper');
        const navLinks = document.querySelectorAll('.nav-links-wrapper li');

        const navCollapses = document.querySelectorAll('.nav-collapse');

        //Animate Links

        function toggleAllCollapse(id){
          const navCollapses = document.querySelectorAll('.nav-collapse');
          navCollapses.forEach((navCollapse, i) => {
            if (id !== navCollapse.getAttribute('id')) {
              const navLinksUl = navCollapse.parentElement.nextElementSibling.querySelectorAll('ul');

              navLinksUl.forEach((navLinkUl, i) => {
                  navLinkUl.style.height = '0px';
                  navLinkUl.style.marginTop = '0px';
                  navLinkUl.style.overflow = 'hidden';
              });

              const navLinks = navCollapse.parentElement.nextElementSibling.querySelectorAll('li');
              navLinks.forEach((link, index) => {
                link.style.animation = ''
              });

              navCollapse.classList.add('collapsed');

            }
          });
        }


        navCollapses.forEach((navCollapse, i) => {
          function toggleCollapse(e){

            const button = e.target.closest('.nav-collapse');
            toggleAllCollapse(button.getAttribute('id'));

            button.classList.toggle('collapsed');

            if (!button.classList.contains('collapsed')) {
              if (  button.closest('.nav-area-wrapper')?.previousElementSibling) {
                button.closest('.nav-area-wrapper')?.previousElementSibling.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
              }else{
                button.closest('.nav-area-wrapper')?.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
              }
            }



            const navLinksUl = button.parentElement.nextElementSibling.querySelectorAll('ul');

            const navLinks = button.parentElement.nextElementSibling.querySelectorAll('li');



            navLinksUl.forEach((navLinkUl, i) => {
              if(navCollapse.classList.contains('collapsed')) {
                navLinkUl.style.height = '0px';
                navLinkUl.style.overflow = 'hidden';

                if (navLinkUl.getAttribute('id') == 'tophat-right' || navLinkUl.classList.contains('primary-right-ul')) {
                  navLinkUl.style.marginTop = '0px';
                }
              }else {

                let countLi = 0;
                navLinkUl.closest('ul')?.querySelectorAll('li')?.forEach((li, i) => {
                  if (!li.classList.contains('cart-empty') || !document.body.classList.contains('body-cart-empty') ) {
                    countLi++;
                  }
                });

                navLinkUl.style.height = `${countLi * 55}px`;
                navLinkUl.style.overflow = 'visible';

                if (navLinkUl.getAttribute('id') == 'tophat-right' || navLinkUl.classList.contains('primary-right-ul')) {
                  navLinkUl.style.marginTop = '0px';
                }
              }
            });

            navLinks.forEach((link, index) => {
              if(navCollapse.classList.contains('collapsed')) {
                link.style.animation = ''
              }else{
                link.style.animation = `navLinkFade 0.5s ease forwards`;
              }
            });
          }

          navCollapse.addEventListener('click', toggleCollapse.bind(this));
        });

        burger.addEventListener('click', () =>{
            //Toggle nav
            nav.classList.toggle('nav-active');

            //Burger Animation
            burger.classList.toggle('toggle');
            // if () {
            //   navCollapses[0].classList.add('collapsed');
            // }

            // if (burger.classList.contains('toggle')) {
            //   document.querySelector('.site-header').classList.add('cover-all');
            //   document.querySelector('.site-header').parentElement.style.marginBottom = '149px';
            // }else{
            //   document.querySelector('.site-header').classList.remove('cover-all');
            //   document.querySelector('.site-header').parentElement.style.marginBottom = '0px';
            // }

            if ((!burger.classList.contains('toggle') && !navCollapses[0].classList.contains('collapsed')||
                burger.classList.contains('toggle')
            )) {
              navCollapses[0].click();
            }else{
              toggleAllCollapse('all');
            }
        });
        }

        navSlide();

        if ( window.location.href.indexOf('/?s=') !== -1 ) {
          const menuSearchListItems = document.querySelectorAll('.menu-search');

          menuSearchListItems.forEach((item, i) => {
            item.classList.add('current_page_item');
          });
        }


        clearInterval(menuStateTimeinterval);
      }
    }, 30);
  }


  var searchTimeinterval = setInterval(()=>{
    targetNode = document.body;
    if (targetNode && targetNode.querySelector('.search-post-type')) {

      const forms = targetNode.querySelectorAll('#swg-browse-search-main-search-form');
      forms.forEach((form, i) => {
        const input = form.querySelector('.search-post-type');
        form.addEventListener('submit', function(e){
          if (postType) {
            input.value = postType;
          }
        })
      });



      clearInterval(searchTimeinterval);
    }
  },300);
